// frontend/src/utils/taskHelpers.js

import moment from "moment-timezone";

export const convertToCompanyTime = (dateStr, timezone) => {
  if (!dateStr) return "N/A";
  return moment.utc(dateStr).tz(timezone).format("YYYY-MM-DD HH:mm");
};

export const convertToLocalInput = (dateStr, timezone) => {
  if (!dateStr) return "";
  return moment.utc(dateStr).tz(timezone).format("YYYY-MM-DDTHH:mm");
};

export const convertLocalToUTCStrict = (dateStr, timezone) => {
  if (!dateStr) return "";
  return moment.tz(dateStr, timezone).utc().format("YYYY-MM-DD HH:mm:ss");
};

export const highlightMentions = (text = "") => {
  if (!text) return "";
  const safeText = text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const mentionRegex = /@([A-Za-z0-9_]+(?:\s[0-9]+)?)/g;
  const withMentions = safeText.replace(
    mentionRegex,
    '<span style="color:#1976d2; font-weight:600;">@$1</span>'
  );
  return withMentions.replace(/\n/g, "<br/>");
};

export const formatTrackedTime = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  return `${String(hours).padStart(2, "0")}h ${String(mins).padStart(2, "0")}m`;
};

export const getTimerStatus = (trackedTime) => {
  if (!trackedTime) return { status: "NotStarted", formatted: "00h 00m" };
  if (trackedTime.end_time) return { status: "Ended", ...trackedTime };
  if (trackedTime.is_running) return { status: "Running", ...trackedTime };
  if (trackedTime.total_seconds > 0) return { status: "Paused", ...trackedTime };
  return { status: "NotStarted", ...trackedTime };
};

export const isTaskOverdue = (dueDate, statusObj, companyTimezone) => {
  if (!dueDate) return false;
  const dueDateLocal = moment.utc(dueDate).tz(companyTimezone);
  const isCompleted = ["completed", "done"].includes(statusObj?.key);
  return moment() > dueDateLocal && !isCompleted;
};

export const canUserEditTask = (task, authUser, hasPermission) => {
  const isAssigned = task.assignedUsers?.some((u) => u.id === authUser?.id);
  const isCreator = task.created_by === authUser?.id;
  return (
    hasPermission("task.update") ||
    hasPermission("task.manage.team") ||
    isAssigned ||
    isCreator
  );
};

export const canUserDeleteTask = (task, authUser, hasPermission) => {
  return hasPermission("task.delete");
};